// ==============================|| OVERRIDES - CHECKBOX ||============================== //

import { BorderColor } from "@mui/icons-material";

export default function Checkbox(theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary[300],

          '&.Mui-checked':{
          color:'#0061A3',
        }

        },
       
      }
    }
  };
}
